import synchro_ending from "../../assets/gallery/photos/synchro_ending.png";
import exhibition from "../../assets/gallery/photos/exhibition.png";
import leaf_gradient from "../../assets/gallery/photos/leaf_gradient.png";
import fall from "../../assets/gallery/photos/fall.png";
import line_leaves from "../../assets/gallery/photos/line_leaves.png";
import miguel_rio_branco from "../../assets/gallery/photos/miguel_rio_branco.png";
import synchro_you from "../../assets/gallery/photos/synchro_you.png";
import Alessar from "../../assets/gallery/photos/Alessar.png";
import sunny from "../../assets/gallery/photos/sunny.png";
import fight from "../../assets/gallery/photos/fight.png";
import touch_me_baby from "../../assets/gallery/photos/touch_me_baby.png";
import snowy_noho from "../../assets/gallery/photos/snowy_noho.png";
import synchro_html from "../../assets/gallery/photos/synchro_html.png";
import hotballoon from "../../assets/gallery/photos/hotballoon.png";
import dark_cloud from "../../assets/gallery/photos/dark_cloud.png";
import style_transfer from "../../assets/gallery/photos/style_transfer.png";

const DataPhotos = [
	{src:synchro_ending, name:synchro_ending},
	{src:exhibition, name:exhibition},
	{src:leaf_gradient, name:leaf_gradient},
	{src:fall, name:fall},
	{src:line_leaves, name:line_leaves},
	{src:miguel_rio_branco, name:miguel_rio_branco},
	{src:synchro_you, name:synchro_you},
	{src:Alessar, name:Alessar},
	{src:sunny, name:sunny},
	{src:fight, name:fight},
	{src:touch_me_baby, name:touch_me_baby},
	{src:snowy_noho, name:snowy_noho},
	{src:synchro_html, name:synchro_html},
	{src:hotballoon, name:hotballoon},
	{src:dark_cloud, name:dark_cloud},
	{src:style_transfer, name:style_transfer},
]

export default DataPhotos;